import "../../CSS/HomeCSS/Competition.css";

import flag from "../../../assets/United Arab Emirates.png";
import Accordion from "react-bootstrap/Accordion";
import { useTranslation } from "react-i18next";
import {
  fetchWinningList,
  STATUSES,
} from "../../../redux/getReducer/getWinner";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Animate from "../../../assets/loader.json";
import Lottie from "lottie-react";
import Cookies from "js-cookie";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
const WinningList = () => {
  const { t } = useTranslation();
  const { data: LeaderBoard, status } = useSelector((state) => state.Winner);
  const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(fetchWinningList());
  // }, [dispatch]);


  useEffect(() => {
    dispatch(fetchWinningList());
  }, [dispatch]);


  const cookiedata = Cookies.get("i18next");
  if (status === STATUSES.LOADING) {
    return (
      <div className="my-new-winners-main-container">
        <div className="my-new-winners-card-header">
          <h2>{t("WinnerList")}</h2>
        </div>
        <div className="my-new-winners-data-content">
          <div className="my-new-no-results-card">
            <div className="my-new-watermark-logo"></div>
            <p>{t("Loading...")}</p>
          </div>
        </div>
      </div>
    );
  }

  if (status === STATUSES.ERROR) {
    return (
      <h2
        style={{
          margin: "100px",
        }}
      >
        Something went wrong!
      </h2>
    );
  }
   const count = typeof window !== "undefined" && window.innerWidth < 520 ? 1 : 3;

  return (
    <React.Suspense>
     <div className="my-new-winners-main-container">
    {/* --- Header Styling matching your image --- */}
    <div className="my-new-winners-card-header">
        <h2>{t("WinnerList")}</h2>
        {/* Flag commented out as requested */}
        {/* <img src={flag} alt="" /> */}
    </div>

    <div className="my-new-winners-data-content">
        {!LeaderBoard || LeaderBoard.length === 0 ? (
            
            <div className="my-new-no-results-card">
                <div className="my-new-watermark-logo"></div>
                <p>{t("No Results Available")}</p>
            </div>
        ) : (
            LeaderBoard.map((item, index) => {
                return item.CompetitionWinnerDataV2 &&
                    item.CompetitionWinnerDataV2.length === 0 ? (
                    <div className="my-new-no-results-card" key={index}>
                         <div className="my-new-watermark-logo"></div>
                         <p>{t("No Results Found")}</p>
                    </div>
                ) : (
                    <Accordion key={index} defaultActiveKey="1" className="my-new-winners-accordion">
                        <div className="my-new-winners-item-wrapper">
                            <Accordion.Item eventKey={index}>
                                <Accordion.Header className="my-new-winners-header">
                                    <div className="my-new-winners-header-flex">
                                        <p className="my-new-winners-comp-name">
                                            {cookiedata === "en" ? item.NameEn : item.NameAr}
                                        </p>
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body className="my-new-winners-body">
                                    {item.CompetitionWinnerDataV2 ? (
                                        item.CompetitionWinnerDataV2.map((data, idx) => (
                                            <div className="my-new-winners-row" key={idx}>
                                                <p className="my-new-winners-username">
                                                    {data.CompetitionWinnerSubscriberDataV2 ? (
                                                        data.CompetitionWinnerSubscriberDataV2.FirstName || data.CompetitionWinnerSubscriberDataV2.Name
                                                    ) : "-"}
                                                </p>
                                                <p className="my-new-winners-score">
                                                    {data.CloseCompetitionTotalPoint || data.TotalPoints || data.TotalPoint}
                                                </p>
                                            </div>
                                        ))
                                    ) : null}
                                </Accordion.Body>
                            </Accordion.Item>
                        </div>
                    </Accordion>
                );
            })
        )}
    </div>
</div>
    </React.Suspense>
  );
};
export default WinningList;
